import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const QuotationHeaderForm_QuotationHeader_Fragment = graphql(`
  fragment QuotationHeaderForm_QuotationHeader_Fragment on QuotationHeader {
    _id
    interventionDate
    modalities
    note
    paymentMethodId
    paymentTermId
    validityPeriodId
  }
`);

export type QuotationHeaderForm_QuotationHeader = ResultOf<
  typeof QuotationHeaderForm_QuotationHeader_Fragment
>;
